import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface DraftRejectedProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  hasDraftReturn: boolean
  isDraftReturnDownloadable: boolean
  requestDraftApprovalLabel: string
  onReportOpenItems: () => unknown
  onRequestDraftApproval: () => unknown
  extensionActions?: ReactNode
}

export function DraftRejectedProgressionActions({
  isAnyExtensionFlowAvailable,
  hasDraftReturn,
  isDraftReturnDownloadable,
  requestDraftApprovalLabel,
  onReportOpenItems,
  onRequestDraftApproval,
  extensionActions,
}: DraftRejectedProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          label="Report Open Items"
          variant="secondary"
          size="wide-slim"
          onPress={onReportOpenItems}
          testId="job-progression-set-open-items-button"
        />
      </CardContent>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label={requestDraftApprovalLabel}
          variant="primary"
          size="wide-slim"
          isDisabled={hasDraftReturn && !isDraftReturnDownloadable}
          onPress={onRequestDraftApproval}
          testId="job-progression-set-draft-in-review-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}
